export default __webpack_public_path__ + "static/media/ppt.b4d2c1a1.png";